(() => {
  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  const updateHeader = () => headerGroup?.classList.toggle('mm-header-scrolled', window.scrollY > 16);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const categoryLinks = Array.from(document.querySelectorAll('.mm-discovery-bar__link'));
  const currentUrl = new URL(window.location.href);
  const currentCategory = categoryLinks.find((link) => {
    const target = new URL(link.href, window.location.origin);
    if (target.pathname !== currentUrl.pathname) return false;
    return Array.from(target.searchParams.entries()).every(([key, value]) => currentUrl.searchParams.get(key) === value);
  });
  if (currentCategory) {
    categoryLinks.forEach((link) => {
      link.classList.remove('mm-discovery-bar__link--primary', 'mm-discovery-bar__link--current');
      link.removeAttribute('aria-current');
    });
    currentCategory.classList.add('mm-discovery-bar__link--current');
    currentCategory.setAttribute('aria-current', 'page');
  }

  const getPurchaseButton = (productInfo) =>
    productInfo?.querySelector('.product__info-container .product-form__submit');

  const setPurchaseLabel = (button, label) => {
    const labelNode = button?.querySelector('span');
    if (labelNode) labelNode.textContent = label;
  };

  const initializePurchaseState = () => {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      const button = getPurchaseButton(productInfo);
      const picker = productInfo.querySelector('variant-selects, variant-radios');

      if (!button) return;
      if (!picker || button.dataset.mmExplicitChoice !== 'true') {
        if (!button.disabled) document.body.classList.add('mm-mobile-purchase-ready');
        return;
      }

      productInfo.dataset.mmChoiceMade = 'false';
      picker.querySelectorAll('select').forEach((select) => {
        select.selectedIndex = -1;
      });
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      setPurchaseLabel(button, 'Select an option');
    });
  };

  initializePurchaseState();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant } }) => {
      const productInfo = document.querySelector(`product-info[data-section="${CSS.escape(sectionId)}"]`);
      const button = getPurchaseButton(productInfo);
      if (!productInfo || !button || button.dataset.mmExplicitChoice !== 'true') return;

      productInfo.dataset.mmChoiceMade = 'true';
      if (!variant?.available) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        setPurchaseLabel(button, variant ? window.variantStrings.soldOut : window.variantStrings.unavailable);
        return;
      }

      const priceNode =
        productInfo.querySelector('[id^="price-"] .price--on-sale .price-item--sale') ||
        productInfo.querySelector('[id^="price-"] .price-item--regular');
      const price = priceNode?.textContent.trim();
      const variantTitle = variant.public_title || variant.title;
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      setPurchaseLabel(button, `Add ${variantTitle}${price ? ` · ${price}` : ''}`);
      document.body.classList.add('mm-mobile-purchase-ready');
    });
  }
})();
